import React from 'react';

const PHASES = [
  { key: 'setup', label: 'Setup' },
  { key: 'influence', label: 'Influence' },
  { key: 'submission', label: 'Submission' },
  { key: 'composition', label: 'Composition' },
  { key: 'voting', label: 'Voting' },
  { key: 'complete', label: 'Complete' },
];

export const PhaseIndicator = ({ currentPhase }) => {
  const currentIndex = PHASES.findIndex(p => p.key === currentPhase);
  const currentPhaseLabel = PHASES[currentIndex]?.label || currentPhase;

  return (
    <div className="flex flex-col items-center">
      {/* Mobile: show current phase name above circles */}
      <div className="sm:hidden text-sm text-primary-600 font-semibold mb-2">
        {currentPhaseLabel}
      </div>
      <div className="flex items-center justify-center space-x-1 sm:space-x-2">
        {PHASES.map((phase, index) => {
          const isActive = phase.key === currentPhase;
          const isPast = index < currentIndex;
          const isFuture = index > currentIndex;

          return (
            <React.Fragment key={phase.key}>
              <div className="flex flex-col items-center">
                <div
                  className={`
                    w-7 h-7 sm:w-8 sm:h-8 text-xs rounded-full flex items-center justify-center font-medium
                    ${isActive ? 'bg-primary-600 text-white' : ''}
                    ${isPast ? 'bg-primary-200 text-primary-700' : ''}
                    ${isFuture ? 'bg-gray-200 text-gray-500' : ''}
                  `}
                >
                  {isPast ? (
                    <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                    </svg>
                  ) : (
                    index + 1
                  )}
                </div>
                {/* Desktop: show phase label under each circle */}
                <span className={`
                  text-xs mt-1 hidden sm:block
                  ${isActive ? 'text-primary-600 font-medium' : 'text-gray-500'}
                `}>
                  {phase.label}
                </span>
              </div>
              {index < PHASES.length - 1 && (
                <div
                  className={`
                    w-3 sm:w-6 h-0.5 sm:mt-[-12px]
                    ${index < currentIndex ? 'bg-primary-400' : 'bg-gray-200'}
                  `}
                />
              )}
            </React.Fragment>
          );
        })}
      </div>
    </div>
  );
};
